<h2 class="text-center" *ngIf="pagelet.stringParam('Title')">{{ pagelet.stringParam('Title') }}</h2>

<ng-container *ngIf="listStyle === 'carousel'; else list">
  <ng-container *ngIf="categoryIDs$ | async as categoryIDs">
    <swiper [config]="swiperConfig">
      <ng-template *ngFor="let categoryID of categoryIDs" swiperSlide>
        <custom-category-tile [categoryUniqueId]="categoryID"></custom-category-tile>
      </ng-template>
    </swiper>
  </ng-container>
</ng-container>

<ng-template #list>
  <div class="product-list row" [ngClass]="CSSclass">
    <ng-container *ngIf="categoryIDs$ | async as categoryIDs">
      <ng-container *ngFor="let categoryID of categoryIDs">
        <div [ngClass]="listItemCSSClass">
          <custom-category-tile [categoryUniqueId]="categoryID"></custom-category-tile>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
